export type PriceType = {
  discount: number;
  discountedAmount: number;
  grossPrice: number;
  smallTile?: boolean;
  hasSubProducts: boolean;
  promotionTotal: number | undefined;
  isBulkDiscountable: boolean | undefined;
};

export const Price: React.FC<PriceType> = ({
  discount,
  discountedAmount,
  grossPrice,
  smallTile = false,
  hasSubProducts,
  promotionTotal,
  isBulkDiscountable,
}) => {
  const discountable =
    (isBulkDiscountable && discount) || hasSubProducts || promotionTotal;

  if (smallTile === true) {
    const discountStyle = discountable
      ? 'text-xs line-through font-interMedium text-grey-dark'
      : 'text-sm leading-[18px] font-interMedium text-black';
    return (
      <div className="flex items-center">
        {discountable ? (
          <span className="font-interMedium text-sm leading-[18px] text-black">
            ${discountedAmount?.toFixed(2)}
          </span>
        ) : null}
        <span className={`self-center ${discountStyle} pl-1`}>
          ${grossPrice?.toFixed(2)}
        </span>
      </div>
    );
  }
  const discountStyle = discountable
    ? 'text-sm lg:text-xl line-through text-grey-dark'
    : 'text-3xl leading-6 font-interSemibold';
  return (
    <div className="flex flex-row-reverse">
      <span
        className={`self-center lg:leading-[30px] ${discountStyle} pr-0 lg:pr-3`}
      >
        ${grossPrice?.toFixed(2)}
      </span>
      {discountable ? (
        <span className="pr-2 font-interSemibold text-3xl leading-6 text-success-secondary lg:leading-[30px]">
          ${discountedAmount?.toFixed(2)}
        </span>
      ) : null}
    </div>
  );
};
